import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NeoTipoDocIdentidadService } from '../../../comun/services/neoTipoDocIdentidad.service';
import { NeoTipoDocIdentidad } from '../../../comun/models/neoTipoDocIdentidad';
import { AlertService } from '../../../services/alert.service';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

@Component({
    selector: 'app-modificar-usuario-if-principal',
    templateUrl: './modificar-usuario-if-principal.component.html',
    styleUrls: ['./modificar-usuario-if-principal.component.scss'],
    providers: [NeoTipoDocIdentidadService, NeoIntermediarioFinancieroService],
    standalone: false
})
export class ModificarUsuarioIfPrincipalComponent implements OnInit {
  public filterForm: UntypedFormGroup;
  listaUsuarios: any[] = [];
  listaDocumentos: NeoTipoDocIdentidad[] = [];
  public user : any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _neoTipoDocIdentidadService: NeoTipoDocIdentidadService,
    private alertService: AlertService,
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _userIntermediarioService: UserService,
    private router: Router,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userIntermediarioService.getUser();
    this.filterForm = this.formBuilder.group({
      tipoDocumento: [null],
      numeroDocumento: [null],
      nombresYApellidos: [null],
      idCliente: [this.user.idCliente],
    });
  }

  ngOnInit(): void {
    this._neoTipoDocIdentidadService.getTiposDocIdentidad().subscribe(
      (response) => {
        this.listaDocumentos = response.filter(
          (documento) => documento.personaJuridica != 1 && documento.idTipoDocIdentidad != 4 && documento.idTipoDocIdentidad != 6
        );
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,
          'No fue posible al cargar los tipos de documento'
        );
      }
    );
  }

  isValidForm(field: string) {
    return (
      (this.filterForm.get(field)?.dirty ||
        this.filterForm.get(field)?.touched) &&
      this.filterForm.get(field)?.invalid
    );
  }

  filtrar() {
    if (this.filterForm.get('tipoDocumento').value != null) {
      this.filterForm
        .get('tipoDocumento')
        .setValue(Number(this.filterForm.get('tipoDocumento').value));
    }
    if (!this.filterForm.get('tipoDocumento').value) {
      this.filterForm.get('tipoDocumento').setValue(null);
    }
    if (!this.filterForm.get('numeroDocumento').value) {
      this.filterForm.get('numeroDocumento').setValue(null);
    }
    if (!this.filterForm.get('nombresYApellidos').value) {
      this.filterForm.get('nombresYApellidos').setValue(null);
    }
    if (
      this.filterForm.get('tipoDocumento').value != null ||
      this.filterForm.get('numeroDocumento').value != null ||
      this.filterForm.get('nombresYApellidos').value != null
    ) {
      this._neoIntermediarioFinancieroService
        .getFilterUsuarios(this.filterForm.value)
        .subscribe(
          (response) => {
            if (response['exitoso'] == true) {
              this.listaUsuarios = response['usuarios'];
              if (this.listaUsuarios.length == 0) {
                this._sweetAlert.errorModal("Error!",true,'No se encontraro resultados');
              }
            } else {
              this._sweetAlert.errorModal("Error!",true,response['error']);
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!",true,'No fue posible conectar con el servidor');
          }
        );
    } else {
      this.listaUsuarios = [];
      this._sweetAlert.errorModal("Error!",true,
        'Debe seleccionar por lo menos uno de los criterios'
      );
    }
  }

  editarFila(i) {
    var idUsuario = this.listaUsuarios[i].idUsuario;
    this.router.navigate([
      'intermediario/administracion/modificarUsuarioIf/' + idUsuario,
    ]);
  }
}
